import React from 'react';
import { Modal } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import './TranslationSavedModal.css';

const TranslationSavedModal = ({
  isOpen,
  onClose,
  onGoToTranslation,
  targetLanguageLabel = '',
  keyword = '',
  mode = 'create',
}) => {
  const { t } = useTranslation();
  const isUpdate = mode === 'update';
  const language = String(targetLanguageLabel || '').trim() || t('la langue cible');
  const keywordLabel = String(keyword || '').trim() || t('votre texte');

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="translation-saved-modal"
      backdrop
      keyboard
      centered
    >
      <div className="translation-saved-modal-content">
        <div className="translation-saved-modal-body">
          <div className="translation-saved-modal-icon-wrap" aria-hidden="true">
            <img
              src="/Images/Typix_Traduction-selection.png"
              alt=""
              className="translation-saved-modal-icon"
            />
          </div>
          <h2 className="translation-saved-modal-title">
            {isUpdate
              ? t('Texte traduit modifié avec succès')
              : t('Traduction enregistrée')}
          </h2>
          {isUpdate ? (
            <p className="translation-saved-modal-message">
              {t('La Traduction en')}
              {' '}
              <strong>
                «
                {language}
                »
              </strong>
              {' '}
              {t('de')}
              {' '}
              <strong>
                «
                {keywordLabel}
                »
              </strong>
              {' '}
              {t('a bien été modifiée.')}
            </p>
          ) : (
            <p className="translation-saved-modal-message">
              {t('La Traduction en')}
              {' '}
              <strong>
                «
                {language}
                »
              </strong>
              {' '}
              {t('de')}
              {' '}
              <strong>
                «
                {keywordLabel}
                »
              </strong>
              {' '}
              {t('a bien été enregistrée. Elle est désormais disponible dans la section')}
              {' '}
              <strong className="translation-saved-modal-highlight">{t('Traduction IA')}</strong>
              {t(', où vous pouvez la relire, l\'ajuster et la publier.')}
            </p>
          )}
        </div>
        <div className="translation-saved-modal-footer">
          {isUpdate ? (
            <button
              type="button"
              className="translation-saved-modal-primary-button"
              onClick={onClose}
            >
              {t('Fermer')}
            </button>
          ) : (
            <>
              <button
                type="button"
                className="translation-saved-modal-secondary-button"
                onClick={onClose}
              >
                {t('Rester ici')}
              </button>
              <button
                type="button"
                className="translation-saved-modal-primary-button"
                onClick={onGoToTranslation}
              >
                {t('Aller à Traduction IA')}
                {' '}
                →
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TranslationSavedModal;
